'use client';

import { QueryKeys } from '@/constants/query-keys';
import { FeatureFlags } from '@/types/feature-flags';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

type FeatureFlagsProviderProps = {
  initialFeatureFlags: FeatureFlags;
};

export const FeatureFlagsProvider = ({ initialFeatureFlags }: FeatureFlagsProviderProps): null => {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.setQueryData(QueryKeys.global.featureFlags, initialFeatureFlags);
  }, [queryClient, initialFeatureFlags]);

  return null;
};
